import { BrandTile } from '@/components/BrandTile';
import { useSession } from '@/features/session/SessionProvider';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  Avatar,
  Dropdown,
  ListItemDecorator,
  Menu,
  MenuButton,
  MenuItem,
  Stack,
  Typography,
} from '@mui/joy';

/** «Олена Коваль» → «ОК». */
const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0].toUpperCase())
    .join('');

/** «Gasbi AI» and the signed-in user, whose menu signs out of the chat and of Identity Server (ADR-0004 §2.6). */
export const TopBar = () => {
  const { state, signOut } = useSession();
  const name = state.status === 'signedIn' ? state.user.name : '';

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap={1.5}
      sx={{
        px: 3,
        height: 56,
        flexShrink: 0,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.surface',
      }}
    >
      <BrandTile size={32} />
      <Typography level='title-lg' sx={{ flex: 1 }}>
        Gasbi AI
      </Typography>
      <Dropdown>
        <MenuButton
          variant='plain'
          color='neutral'
          startDecorator={
            <Avatar size='sm' color='primary' variant='solid'>
              {initials(name)}
            </Avatar>
          }
          endDecorator={<KeyboardArrowDownIcon fontSize='small' />}
        >
          {name}
        </MenuButton>
        <Menu size='sm' placement='bottom-end'>
          <MenuItem onClick={() => void signOut()}>
            <ListItemDecorator>
              <LogoutIcon fontSize='small' />
            </ListItemDecorator>
            Вийти
          </MenuItem>
        </Menu>
      </Dropdown>
    </Stack>
  );
};
